"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechnologicalTelepathy = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Tags_1 = require("../../../cards/Tags");
class TechnologicalTelepathy {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.TECHNOLOGICAL_TELEPATHY;
        this.description = 'Draw 1 card for every 3 Science tags (max 5 sets). Influence counts as Science tags.';
        this.revealedDelegate = PartyName_1.PartyName.POPULISTS;
        this.currentDelegate = PartyName_1.PartyName.EMPOWER;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const total = player.getTagCount(Tags_1.Tags.SCIENCE, 'raw') + turmoil.getPlayerInfluence(player);
            const setsCount = Math.floor(total / 3);
            const amount = Math.min(setsCount, 5);
            if (amount > 0)
                player.drawCard(amount);
        });
    }
}
exports.TechnologicalTelepathy = TechnologicalTelepathy;
//# sourceMappingURL=TechnologicalTelepathy.js.map